import { AppBar } from '@mui/material'
import Grid from '@config/Grid/Grid'
import { headerStyles } from './Header.styles'
import styles from './Header.module.scss'
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch'

function Header() {
  return (
    <AppBar position="fixed" sx={headerStyles}>
      <Grid>
        <div className={`start-1 col-12 align-center ${styles.headerWrapper}`}>
          <div className={`${styles.headerLogoContainer}`}>
            <p className="logo-font">
              <mark className="mark-white">MENU</mark>
              <mark className="mark-orange">!</mark>
            </p>
            <p className="logo-font-small">
              <mark className="mark-orange">WOS</mark>
            </p>
          </div>
          <div className={styles.headerRightSidePanel}>
            <LanguageSwitch />
          </div>
        </div>
      </Grid>
    </AppBar>
  )
}

export default Header
